import React from "react";

interface SnapPackProps {
    fill?: string;
}

function SnapPack(props: SnapPackProps) {
    const { fill } = props;
    return (
        <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 60.8 77.6" height={55} width={56}>
            <defs>
                <style>
                    {`
                    .st0 {
                        fill: none;
                        stroke: #000;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 2px;
                    }

                    .st1 {
                        fill: #fff;
                    }

                    .st2 {
                        fill: ${fill};
                    }
                    `}
                </style>
            </defs>
            <polygon className="st2" points="57.3 51.3 1 51.3 3.5 26.3 59.8 26.3 57.3 51.3" />
            <path d="M59.8,27.3c-.5,0-.9-.4-1-.9l-2.2-22.8c0-.9-.8-1.6-1.8-1.6H4c-.5,0-1,.2-1.3.6-.3.4-.5.9-.4,1.4l2.2,22.2c0,.5-.3,1-.9,1.1-.6,0-1-.3-1.1-.9L.3,4.1c-.1-1.1.2-2.1,1-2.9.7-.8,1.7-1.2,2.8-1.2h50.7c1.9,0,3.6,1.5,3.7,3.4l2.2,22.8c0,.5-.3,1-.9,1.1,0,0,0,0,0,0Z" />
            <path d="M56.7,77.6H6c-1.9,0-3.5-1.5-3.7-3.4L0,51.4c0-.5.3-1,.9-1.1.5,0,1,.3,1.1.9l2.2,22.8c0,.9.8,1.6,1.7,1.6h50.7c.5,0,1-.2,1.3-.6.3-.4.5-.8.4-1.3l-1.7-17.8c0-.5.3-1,.9-1.1.6,0,1,.3,1.1.9l1.7,17.8c.1,1.1-.2,2.1-1,2.9-.7.8-1.7,1.2-2.8,1.2Z" />
            <path d="M57.3,52.3s0,0,0,0c-.5,0-1-.5-.9-1.1l2.4-24H4.4l-2.4,24.2c0,.6-.5,1-1.1.9-.5,0-1-.5-.9-1.1l2.5-25.1c0-.5.5-.9,1-.9h56.3c.3,0,.6.1.7.3.2.2.3.5.3.8l-2.5,25.1c0,.5-.5.9-1,.9Z" />
            <g>
                <path className="st1" d="M28.8,40.3H10.8c-1.1,0-2-.9-2-2l.4-4.1c0-1.1.9-2,2-2h17.9c1.1,0,2,.9,2,2l-.4,4.1c0,1.1-.9,2-2,2Z" />
                <path d="M28.8,41.3H10.8c-1.7,0-3-1.3-3-3l.4-4.2c0-1.6,1.3-2.9,3-2.9h17.9c1.7,0,3,1.3,3,3l-.4,4.2c0,1.6-1.3,2.9-3,2.9ZM11.2,33.2c-.5,0-1,.4-1,1l-.4,4.2c0,.5.5.9,1,.9h17.9c.5,0,1-.4,1-1l.4-4.2c0-.5-.5-.9-1-.9H11.2Z" />
            </g>
            <path d="M54.8,35.7h-17.9c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M54.5,39.8h-17.9c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M28.9,46.3H11c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M27.2,9.3H9.3c-.6,0-1-.4-1-1s.4-1,1-1h17.9c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M51.1,14.6H9.9c-.6,0-1-.4-1-1s.4-1,1-1h41.2c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M51.5,19.8H10.3c-.6,0-1-.4-1-1s.4-1,1-1h41.2c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <g>
                <path d="M51.1,64.9h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z" />
                <path d="M51.5,70h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            </g>
            <g>
                <path d="M30.1,64.9c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z" />
                <path d="M30.6,70c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            </g>
            <path d="M50.6,59.7h-17.5c-.6,0-1-.4-1-1s.4-1,1-1h17.5c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <path d="M29.7,59.7c-.6,0-1-.4-1-1s.4-1,1-1h0c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            <g>
                <path d="M2.5,52.3H1C.4,52.3,0,51.9,0,51.3s.4-1,1-1h1.5c.6,0,1,.4,1,1s-.4,1-1,1Z" />
                <path d="M52.6,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM46.4,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM40.1,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM33.8,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM27.6,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM21.3,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM15,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1ZM8.8,52.3h-3.1c-.6,0-1-.4-1-1s.4-1,1-1h3.1c.6,0,1,.4,1,1s-.4,1-1,1Z" />
                <path d="M57.3,52.3h-1.5c-.6,0-1-.4-1-1s.4-1,1-1h1.5c.6,0,1,.4,1,1s-.4,1-1,1Z" />
            </g>
            <path className="st0" d="M31.8,70.5" />
            <path d="M14.6,71.3c-.5,0-1.1-.2-1.5-.4,0,0,0,0,0,0-.8-.6-1.2-1.5-1.2-2.5v-2.2c.1,0-1.7-1.6-1.7-1.6-.8-.6-1.1-1.7-.9-2.7.2-1,1-1.7,2.1-1.8l2-.3.7-1.9c.4-1,1.3-1.6,2.3-1.6s1.9.5,2.4,1.4l1.2,2.1,2.3.3c1,.2,1.7.8,2.2,1.6.4,1,.3,2.1-.4,2.8l-1.4,1.5.6,2.1c.3,1,0,2-.8,2.6,0,0,0,0-.1,0-.8.5-1.8.6-2.7.2l-2.1-1-1.8,1c-.4.2-.8.3-1.2.3ZM14.1,69.2c.2.1.5.1.6,0l2.3-1.3c.3-.2.6-.2.9,0l2.5,1.3c.2,0,.4.1.7,0,0-.1.2-.2,0-.5l-.8-2.7c0-.3,0-.7.2-.9l1.7-1.9c.2-.2,0-.5,0-.6,0-.1-.3-.4-.7-.5l-2.7-.4c-.3,0-.6-.2-.7-.5l-1.5-2.5c-.3-.5-.9-.6-1.1-.2l-.9,2.4c-.1.3-.4.6-.8.6l-2.6.4c-.2,0-.3.2-.4.3,0,.3,0,.5.2.7l2.2,1.9c.2.2.4.5.3.8l-.2,2.7c0,.2.1.5.4.7Z" />
        </svg>
    );
}

export default SnapPack;
